import { API } from "@network";
import { API_CHAIN_LIST } from "@network/URL";

export const getListChain = (body?: any, paging?: any) =>
  API.post(
    `${API_CHAIN_LIST}?page=${paging?.pageIndex}&per_page=${paging?.pageSize}`,
    body
  );
